module.exports = __webpack_public_path__ + "static/flags/CA-c5af78be210792d2dd77aa77c3b3c563.gif";